export default "__VITE_ASSET__C0$Srj2g__"